import * as React from 'react';

import * as PropTypes from 'prop-types';
import { TileLayer } from 'react-leaflet';

interface Props {
  type?: string;
  zIndex?: number;
}

export default class GoogleTileLayer extends React.Component<Props> {
  static propTypes = {
    type: PropTypes.oneOf(['h', 's', 'm', 'p', 's,h'])
  };

  static defaultProps = {
    type: 's,h'
  };

  render() {
    const { type, zIndex } = this.props;
    return (
      <TileLayer
        url={`http://{s}.google.com/vt/lyrs=${type}&x={x}&y={y}&z={z}`}
        subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
        zIndex={zIndex}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GoogleTileLayer/index.tsx